import { Link } from '@tanstack/react-router'
import { HomeIcon, RotateCcwIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button } from '@/components'
import { SUPPORT_URL } from '@/config'
import { BaseError } from './BaseError'

interface UnexpectedErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: Error | null
  reset?: () => void
}

const UnexpectedError = forwardRef<HTMLDivElement, UnexpectedErrorProps>(
  ({ className, error, reset, ...props }, ref) => {
    return (
      <BaseError
        title="Something went wrong"
        description={
          error?.message || 'An unexpected error occurred. Please try again.'
        }
        help={
          <>
            If the issue persists, please{' '}
            <a
              href={SUPPORT_URL}
              target="_blank"
              className="underline"
              rel="noopener"
            >
              contact support
            </a>{' '}
            and let us know what happened.
          </>
        }
        withLogout
        {...props}
        ref={ref}
      >
        <Button onClick={() => reset?.()}>
          <RotateCcwIcon className="size-4" />
          Try again
        </Button>
        <Button theme="outline" asChild>
          <Link to="/">
            <HomeIcon className="size-4" />
            Go home
          </Link>
        </Button>
      </BaseError>
    )
  },
)
UnexpectedError.displayName = 'UnexpectedError'

export { UnexpectedError }
